export const replaceAll = function (text: string, search: string, replacement: string) {
  return text.replace(new RegExp(search, 'g'), replacement);
};
